import React, { useState, useEffect } from "react";
import phoneCall from "../../../src/assets/phone-call.png";
import whatsappIcon from "../../../src/assets/whatsapp.png";
import { useLanguage } from "../contextApi/languageContext";

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { language } = useLanguage();

  console.log("language in scroll", language);

  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div
      className=""
      style={{
        position: "fixed",
        bottom: 20,
        left: language === "ar" ? "auto" : 10,
        right: language === "ar" ? 10 : "auto",
        display: "flex",
        flexDirection: "column",
        gap: 15,
        zIndex: 99,
      }}
    >
      <a
        href="https://wa.me/971551200086"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="whatsapp-btn"
      >
        <img
          src={whatsappIcon}
          alt="WhatsApp"
          style={{ width: "40px", height: "40px" }}
        />
      </a>

      <a
        href="tel:+971551200086"
        aria-label="Call us"
        className="phone-call-btn"
      >
        <img
          src={phoneCall}
          alt="Phone Call"
          style={{ width: "40px", height: "40px" }}
        />
      </a>

      <button
        onClick={scrollToTop}
        className={`scroll-top-btn ${isVisible ? "show" : "hide"}`}
        aria-label="Scroll to top"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="scroll-icon"
        >
          <path d="M12 4L4 12H9V20H15V12H20L12 4Z" fill="currentColor" />
        </svg>
      </button>
    </div>
  );
};

export default ScrollToTop;
